export function isArray(obj: unknown): obj is Array<unknown> {
  return Array.isArray(obj);
}

export function areArrays(obj1: unknown, obj2: unknown): boolean {
  return isArray(obj1) && isArray(obj2);
}
